import * as React from 'react';
import { Box } from '../Box/Box.js';
import { CarouselChildStyled } from './CarouselChild.styled.js';

var CarouselCard = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    fullWidth = props.fullWidth,
    inView = props.inView,
    maxWidth = props.maxWidth,
    me = props.me,
    minWidth = props.minWidth,
    mx = props.mx,
    pb = props.pb,
    scrollSnapAlign = props.scrollSnapAlign,
    scrollSnapStop = props.scrollSnapStop,
    isHiddenCard = props.isHiddenCard,
    ariaLabel = props.ariaLabel;
  if (fullWidth) {
    return /*#__PURE__*/React.createElement(Box, {
      as: "section",
      flexShrink: 0,
      scrollSnapAlign: scrollSnapAlign,
      scrollSnapStop: scrollSnapStop,
      width: "100%",
      "aria-hidden": isHiddenCard ? true : undefined,
      inert: isHiddenCard ? '' : undefined,
      "aria-label": ariaLabel
    }, inView && children);
  }
  return /*#__PURE__*/React.createElement(CarouselChildStyled, {
    ref: ref,
    forwardedAs: "section",
    display: "flex",
    justifyContent: "center",
    minWidth: minWidth ? "".concat(minWidth, "px") : undefined,
    maxWidth: maxWidth ? "".concat(maxWidth, "px") : undefined,
    me: me,
    mx: mx,
    pb: pb,
    scrollSnapAlign: scrollSnapAlign,
    scrollSnapStop: scrollSnapStop,
    "aria-hidden": isHiddenCard ? true : undefined,
    inert: isHiddenCard ? '' : undefined,
    "aria-label": ariaLabel
  }, inView && children);
});
var CarouselCardMemoized = /*#__PURE__*/React.memo(CarouselCard);
CarouselCardMemoized.displayName = 'CarouselCard';

export { CarouselCardMemoized as CarouselCard };
//# sourceMappingURL=CarouselCard.js.map
